import React from "react";
import Bus from "../utils/bus";
let BUS = new Bus();

class ExplainerVideo extends React.Component {
  constructor(props) {
    super(props);
    this.triggerVideo = this.triggerVideo.bind(this);
  }

  triggerVideo(video) {
    BUS.trigger("OPEN_VIDEO_MODAL", { url: video.url });
  }

  render() {
    const { copy, title, video, image } = this.props.data;
    return (
      <div className="ExplainerVideo">
        <div className="cover">
          <div className="bg">
            <img src={image} />
          </div>
          <div className="internal">
            <h4>{title}</h4>
            <img
              className="playbutton"
              onClick={() => {
                this.triggerVideo(video);
              }} src="/images/play.png" alt="play video button" />
          </div>
        </div>
      </div>
    );
  }
}

export default ExplainerVideo;



// WEBPACK FOOTER //
// ./src/home/explainer-video.js